module.exports = __webpack_public_path__ + "img/user-m.75fc84e.svg";